"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as c } from "react";
import i from "../components/Icon/SvgIcon.js";
const l = (e) => /* @__PURE__ */ o(
  i,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.987 22c-2.789.001-3.825-2.656-3.983-4.081a.625.625 0 0 1 .55-.69.63.63 0 0 1 .692.55c.014.122.374 2.971 2.746 2.971l.08-.001c1.577-.042 2.451-1.106 2.596-2.078.356-2.392 1.889-3.677 3.112-4.334 2.11-1.136 3.181-2.828 3.181-5.031 0-3.569-2.912-6.056-5.526-6.056-1.911 0-3.413.545-4.466 1.62-1.758 1.797-1.72 4.524-1.719 4.551a.626.626 0 0 1-.611.639A.635.635 0 0 1 3 9.451c-.003-.132-.059-3.264 2.067-5.446C6.364 2.675 8.171 2 10.435 2c3.205 0 6.776 3 6.776 7.306 0 2.66-1.328 4.781-3.839 6.132-1.413.759-2.243 1.909-2.468 3.416-.219 1.471-1.5 3.083-3.799 3.145zm11.362-7.241a.62.62 0 0 1-.44-.183.62.62 0 0 1-.002-.883c2.147-2.15 2.147-7.045 0-9.192a.626.626 0 0 1 .884-.885c2.662 2.664 2.662 8.296 0 10.959a.62.62 0 0 1-.442.184M9.216 9.353c0-.52.406-.925.925-.925.52 0 .925.406.925.925a.915.915 0 0 1-.925.925.915.915 0 0 1-.925-.925m-1.25 0c0 1.199.976 2.175 2.175 2.175a2.18 2.18 0 0 0 2.175-2.175 2.18 2.18 0 0 0-2.175-2.175 2.18 2.18 0 0 0-2.175 2.175",
        clipRule: "evenodd"
      }
    )
  }
), m = c(l);
export {
  m as HearingAids,
  m as default
};
